// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1DnSE","error":"Textarea_error__1bDn9","readonly":"Textarea_readonly__lxGdD","disabled":"Textarea_disabled__1yOd-"};